import { IGetRemittanceWithIncompleteDeductionsParams, IRemittanceItemRepositoryResponse, IRemittanceRepository } from "@/core/repositories/remittance";

export class GetRemittanceItemWithIncompleteDeductionsUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IGetRemittanceWithIncompleteDeductionsParams, refetch: boolean = false): Promise<IRemittanceItemRepositoryResponse> {
    return this.remittanceRepository.getRemittanceItemWithIncompleteDeductions(params, refetch);
  }
}
